import React from 'react';
import { Badge } from 'framework/ui/mui-builder';
import { BadgeLayoutProps } from 'framework/ui/uiContract';
import { CANDIDATE_TIMELINE_OFFER_STATUSES } from 'domain/shared/candidate';

type StatusType = keyof typeof CANDIDATE_TIMELINE_OFFER_STATUSES | null;

interface StatusChipProps {
  status: StatusType;
}

const STATUS_CONFIG: Record<string, { label: string; color: BadgeLayoutProps['color'] }> = {
  [CANDIDATE_TIMELINE_OFFER_STATUSES.DRAFT]: { label: 'Draft', color: 'default' },
  [CANDIDATE_TIMELINE_OFFER_STATUSES.FINALIZED]: { label: 'Finalized', color: 'info' },
  [CANDIDATE_TIMELINE_OFFER_STATUSES.SENT]: { label: 'Sent', color: 'primary' },
  [CANDIDATE_TIMELINE_OFFER_STATUSES.CANCELED]: { label: 'Cancelled', color: 'default' },
  [CANDIDATE_TIMELINE_OFFER_STATUSES.ACCEPTED]: { label: 'Accepted', color: 'success' },
  [CANDIDATE_TIMELINE_OFFER_STATUSES.REJECTED]: { label: 'Rejected', color: 'default' },
  null: { label: 'Deleted', color: 'default' },
};

const StatusChip: React.FC<StatusChipProps> = ({ status }) => {
  const config = STATUS_CONFIG[status as string];

  if (!config) return null;

  return (
    <Badge
      color={config.color}
      sx={{
        pl: 1,
        pr: 1,
        fontSize: '10px',
      }}
    >
      {config.label}
    </Badge>
  );
};

export default StatusChip;
